// extracted by mini-css-extract-plugin
export var divider = "blogs-module--divider--MGL4E";
export var row = "blogs-module--row--bj7pT";
export var title = "blogs-module--title--zV4zi";
export var desc = "blogs-module--desc--eXnZ5";